module.exports = __webpack_public_path__ + "static/media/Pickup-4 Door.9013c819.png";